module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('DModal', {
    staticStyle: {
      "z-index": "12312312312312"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "isCloseOnBgClick": false,
      "appendToBody": true,
      "placeInTop": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('div', [_c('h2', [_vm._v("Indberettede engangsydelser i OPUS")]), _vm._v(" "), _c('p', {
    staticClass: "d-modal__subtitle"
  }, [_vm._v("\n            " + _vm._s(_vm.userName) + " · " + _vm._s(_vm.employmentLabel) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__toolbar"
  }, [_c('DoDatePickerRange', {
    attrs: {
      "allowSameDate": true,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "maximumDateRange": 365,
      "dateShortCutsProps": _vm.dateShortCuts
    },
    on: {
      "startChanged": _vm.startDateChanged,
      "endChanged": _vm.endDateChanged
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": _vm.openCreate
    }
  }, [_vm._v("\n          Opret engangsydelse\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [(_vm.isLoading) ? _c('Loader', {
    attrs: {
      "isLoaderModal": true
    }
  }) : [_c('table', {
    staticClass: "do-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "td-date"
  }, [_vm._v("DATO")]), _vm._v(" "), _c('th', {
    staticClass: "td-loenkode"
  }, [_vm._v("LØNKODE")]), _vm._v(" "), _c('th', {
    staticClass: "td-units"
  }, [_vm._v("ENHEDER")]), _vm._v(" "), _c('th', {
    staticClass: "td-units"
  }, [_vm._v("BELØB")]), _vm._v(" "), _c('th', [_vm._v("OMK.STED")]), _vm._v(" "), _c('th', {
    staticClass: "td-system"
  }, [_vm._v("SYSTEM")]), _vm._v(" "), _c('th', {
    staticClass: "td-status"
  }, [_vm._v("STATUS")]), _vm._v(" "), _c('th', {
    staticClass: "th-actions"
  })])]), _vm._v(" "), _c('tbody', [(_vm.displayedPayments.length === 0) ? _c('tr', [_c('td', {
    staticClass: "italic",
    attrs: {
      "colspan": 8
    }
  }, [_vm._v("\n                Ingen engangsydelser i OPUS for perioden\n              ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.displayedPayments), function(row) {
    return _c('tr', {
      key: row.id,
      staticClass: "engangsydelse-row"
    }, [_c('td', {
      staticClass: "td-date"
    }, [_vm._v(_vm._s(row.vDato))]), _vm._v(" "), _c('td', {
      staticClass: "td-loenkode"
    }, [_vm._v(_vm._s(row.vLoenart))]), _vm._v(" "), _c('td', {
      staticClass: "td-units"
    }, [_vm._v(_vm._s(_vm.formatDecimal(row.antal)))]), _vm._v(" "), _c('td', {
      staticClass: "td-units"
    }, [_vm._v(_vm._s(_vm.formatDecimal(row.beloeb)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.afv_omkostningssted || '—'))]), _vm._v(" "), _c('td', {
      staticClass: "td-system"
    }, [_vm._v(_vm._s(row.afsendelses_system || '—'))]), _vm._v(" "), _c('td', {
      staticClass: "td-status"
    }, [_c('span', {
      staticClass: "do-pill do-pill--small",
      class: row.statusClass
    }, [_vm._v(_vm._s(row.vStatus))])]), _vm._v(" "), _c('td', {
      staticClass: "td-actions"
    }, [(row.vStatus === 'I OPUS') ? _c('button', {
      staticClass: "do-bttn do-bttn--small modregn-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openModregn(row)
        }
      }
    }, [_vm._v("Modregn")]) : _vm._e()])])
  })], 2)])]], 2)])]), _vm._v(" "), (_vm.isShowCreate) ? _c('CreateEngangsydelse', {
    attrs: {
      "schoolId": _vm.schoolId,
      "employmentIds": [_vm.employmentId],
      "subtitle": _vm.effectiveCreateSubtitle,
      "prefill": _vm.createPrefill
    },
    on: {
      "created": _vm.onCreated,
      "close": _vm.closeCreate
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-378cee1b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/KMD/EngangsydelserModal.vue
// module id = 1860
// module chunks = 1